import { z } from 'zod';
import { durationLabel } from './internal-meeting.js';
/**
 * Les durées que « Attribuer & planifier » et « Modifier le rendez-vous » **proposent** (#431) :
 * de 30 min à 8 h, puis deux et trois jours — le cas rare d'un rendez-vous qui s'étale.
 *
 * ⚠️ **Une ligne, un début et une durée** (choix du développeur, 15/10) : un rendez-vous sur
 * plusieurs jours n'a rien de dédié. Comme pour le point interne, l'écran propose et la base admet
 * plus (`appointmentDurationSchema`).
 */
export const APPOINTMENT_DURATIONS = [
    30,
    60,
    90,
    120,
    180,
    240,
    300,
    360,
    420,
    480,
    2 * 1440,
    3 * 1440,
];
/** Une heure : la durée d'un rendez-vous qu'on ne règle pas, et celle des rendez-vous d'avant #431. */
export const APPOINTMENT_DEFAULT_DURATION = 60;
/**
 * La journée qu'une enquête réserve (#578) : « journée entière réservée à l'industriel » (point
 * GHP du 21/10). Huit heures, le plus long cran d'un jour sur la roue.
 */
export const INVESTIGATION_DEFAULT_DURATION = 480;
/**
 * La durée d'un **premier** rendez-vous qu'on ne règle pas, selon le type de contrôle (#578). Un
 * déplacement, lui, garde celle du rendez-vous qu'il remplace.
 *
 * ⚠️ La règle tient au type « Enquête » (`investigation`), pas au type de bâti « Industriel » :
 * GHP n'emploie l'enquête que pour l'industriel, et le type de bâti relève de #586.
 */
export function appointmentDefaultDuration(purpose) {
    return purpose === 'investigation'
        ? INVESTIGATION_DEFAULT_DURATION
        : APPOINTMENT_DEFAULT_DURATION;
}
/** Une semaine au plus : au-delà, ce n'est plus un rendez-vous. */
export const appointmentDurationSchema = z
    .int()
    .positive()
    .max(7 * 1440);
/** « 1 h 30 », « 8 h », puis « 2 jours » pour une journée pleine et plus — `durationLabel`. */
export const appointmentDurationLabel = durationLabel;
const PARIS = 'Europe/Paris';
const TIME = new Intl.DateTimeFormat('fr-FR', {
    timeZone: PARIS,
    hour: '2-digit',
    minute: '2-digit',
});
const DAY = new Intl.DateTimeFormat('fr-FR', { timeZone: PARIS, day: '2-digit', month: '2-digit' });
/**
 * L'heure de **fin** d'un rendez-vous, au fuseau de Paris (M24) : « 10:00 », ou « 17/10 09:00 »
 * quand elle tombe un autre jour. `null` sur un instant illisible.
 */
export function appointmentEndLabel(scheduledAt, minutes) {
    const start = new Date(scheduledAt);
    if (Number.isNaN(start.getTime()))
        return null;
    const end = new Date(start.getTime() + minutes * 60_000);
    const time = TIME.format(end);
    return DAY.format(end) === DAY.format(start) ? time : `${DAY.format(end)} ${time}`;
}
//# sourceMappingURL=appointment-duration.js.map